import {z} from 'zod';

import {CheckoutProfileDocumentRowSchema, CheckoutProfileWriteSchema} from '@dms/api/sales';

export const CheckoutProfileFormValuesSchema = CheckoutProfileWriteSchema.innerType().extend({
  documents: z.array(
    CheckoutProfileDocumentRowSchema.extend({
      restrictSeries: z.boolean().optional(),
      restrictTemplates: z.boolean().optional(),
    })
  ),
});

export type CheckoutProfileFormValues = z.infer<typeof CheckoutProfileFormValuesSchema>;
